import styled from "styled-components";

export const PricingTabWrapper = styled.div<{ language: "ar" | "en" }>`
  position: relative;
  .containerDate,
  .containerPricingManagement {
    border-bottom: 1px solid #eaeafd;
    padding-bottom: 24px;
    margin-bottom: 24px;
    > label {
      font-size: 12px;
      font-weight: 400;
      line-height: 14.4px;
      color: #000;
    }
    .dateInputs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      > div {
        width: 100%;
      }
    }
    .numberOfNights {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      border-right: ${(props) =>
        props.language === "ar" ? "2px solid #5b3fff" : "none"};
      border-left: ${(props) =>
        props.language === "en" ? "2px solid #5b3fff" : "none"};
      padding-right: ${(props) => (props.language === "ar" ? "5px" : "none")};
      padding-left: ${(props) => (props.language === "en" ? "5px" : "none")};
      font-size: 12px;
      font-weight: 500;
      line-height: 14.4px;
      margin-top: 12px;
      span {
        padding: 5px 14px;
        color: #8e98a1;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }
  .MuiToggleButtonGroup-firstButton,
  .MuiToggleButtonGroup-middleButton,
  .MuiToggleButtonGroup-lastButton {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
  }

  .byProperty {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    > div {
      width: 100%;
    }
  }

  .rateContainer {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 18px;
    .containerLogoAndLabel {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      .containerIcon {
        width: 20px;
        height: 20px;
        svg {
          width: 100%;
          height: 100%;
        }
      }
      p.label {
        margin: 0;
        font-weight: 700;
        color: #435363;
        font-size: 15px;
        text-transform: capitalize;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .containerInputs {
      width: 100%;
      .containerinput {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p.label {
          margin: 0;
          font-weight: 700;
          color: #435363;
          font-size: 15px;
          text-transform: capitalize;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
`;

export const ChannelsSection = styled.section`
  margin-top: 24px;
`;

export const ChannelsHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 25px;
`;

export const ChannelsHeaderText = styled.span`
  font-weight: 500;
  color: #495057;
`;

export const ChannelsHeaderIcon = styled.div<{ isExpanded: boolean }>`
  color: #6c757d;
`;

export const ChannelsList = styled.div`
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
`;

export const ChannelItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 12px;
`;

export const ChannelItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const ChannelIconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChannelName = styled.span`
  color: #435363;
  font-size: 12px;
  font-weight: 400;
`;

export const ChannelValue = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #5b3fff;
  min-width: 60px;
`;

export const ChannelMoneyIcon = styled.span`
  width: 12px;
  height: 12px;
  margin-inline: 4px;
`;

export const NoChannelsMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: #6c757d;
`;
